<div
  [class.boxed]="isBoxed$ | async"
  [class.horizontal-layout]="(isLayoutVertical$ | async) === false"
  [class.is-mobile]="(isDesktop$ | async) === false"
  [class.vertical-layout]="isLayoutVertical$ | async"
  [class.has-fixed-footer]="(isFooterFixed$ | async) && isFooterVisible$ | async"
  [class.has-footer]="isFooterVisible$ | async"
  [class.scroll-disabled]="scrollDisabled$ | async"
  [class.toolbar-fixed]="isToolbarFixed$ | async"
  [class.sidenav-collapsed]="sidenavCollapsed$ | async"
  [class.content-container]="containerEnabled$ | async"
  [class.with-search]="searchOpen$ | async"
  class="page-container"
>
  <nx-ratenow-ui-progress-bar-loader></nx-ratenow-ui-progress-bar-loader>

  <!-- <ratenow-search></ratenow-search> -->

  @if (this.aplicationType === aplicationTypeName.adminUsers) {
    <ng-container *ngTemplateOutlet="toolbarRef"></ng-container>

    <main class="content overflow-auto">
      <router-outlet></router-outlet>
    </main>
  } @else {
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        #sidenav
        [disableClose]="isDesktop$ | async"
        [fixedInViewport]="(isDesktop$ | async) === false"
        [mode]="(isDesktop$ | async) === false || (isLayoutVertical$ | async) ? 'over' : 'side'"
        [opened]="(isDesktop$ | async) && (isLayoutVertical$ | async) === false"
        class="sidenav"
      >
        <ng-container *ngTemplateOutlet="sidenavRef"></ng-container>
      </mat-sidenav>

      <mat-sidenav #quickpanel [fixedInViewport]="(isDesktop$ | async) === false" class="quickpanel" mode="over" position="end">
        <ng-container *ngTemplateOutlet="quickpanelRef"></ng-container>
      </mat-sidenav>

      <mat-sidenav-content class="sidenav-content">
        <ng-container *ngTemplateOutlet="toolbarRef"></ng-container>

        <main class="content">
          <router-outlet></router-outlet>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  }
</div>
